import { Box, Container } from "@material-ui/core";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useStyles } from "../../quoteDetail.styles";
import { TopBox } from "../../../../components/TopBox";
import { BotBox } from "../../../../components/BotBox";

export const WhatHappensNextSection = ({ hasSpecialBackground }: { hasSpecialBackground?: boolean }) => {
  const classes = useStyles();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  return (
    <Box mt={isMoreThanSm ? "100px" : "50px"} position={"relative"}>
      {hasSpecialBackground && (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <Box bgcolor={hasSpecialBackground ? "#f7f7f7" : "#fff"}>
        <Box
          textAlign={"center"}
          fontSize={isMoreThanSm ? "28px" : "20px"}
          color={"#1e073f"}
          fontWeight={500}
          width={"100%"}
          position={hasSpecialBackground ? "absolute" : "relative"}
          top={hasSpecialBackground ? "82px" : "inherit"}
        >
          What happens <span className={classes.colorOrange}>next</span>
        </Box>
        <Container maxWidth="lg">
          <Box
            display={"flex"}
            pt={hasSpecialBackground ? "42px" : isMoreThanSm ? "75px" : "38px"}
            flexDirection={isMoreThanSm ? "row" : "column"}
            justifyContent={"space-between"}
            maxWidth={"1092px"}
            margin={"0 auto"}
          >
            <Box flex={1} maxWidth={isMoreThanSm ? "292px" : "332px"} margin={isMoreThanSm ? 0 : "0 auto"}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                height={"170px"}
              >
                <img src="images/quote/step_1.svg" alt="Step 1" height={"94.4px"} width={"132.6px"} />{" "}
                <Box
                  fontSize={isMoreThanSm ? "22px" : "18px"}
                  fontWeight={500}
                  lineHeight={isMoreThanSm ? 1.09 : 1.33}
                  color={"#160337"}
                >
                  Step 1
                </Box>
              </Box>
              <Box
                textAlign={"center"}
                fontSize={isMoreThanSm ? "16px" : "14px"}
                lineHeight={isMoreThanSm ? 1.5 : 1.71}
                color={"#4b5462"}
                mt={isMoreThanSm ? "15px" : "8px"}
              >
                Pay your deposit online to book your installation and secure your price
              </Box>
            </Box>

            <Box
              mt={isMoreThanSm ? 0 : "64px"}
              flex={1}
              maxWidth={isMoreThanSm ? "316px" : "332px"}
              margin={isMoreThanSm ? 0 : "0 auto"}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                height={"170px"}
              >
                <img src="images/quote/step_2.svg" alt="Step 2" height={"109px"} width={"110px"} />{" "}
                <Box
                  fontSize={isMoreThanSm ? "22px" : "18px"}
                  fontWeight={500}
                  lineHeight={isMoreThanSm ? 1.09 : 1.33}
                  color={"#160337"}
                >
                  Step 2
                </Box>
              </Box>
              <Box
                textAlign={"center"}
                fontSize={isMoreThanSm ? "16px" : "14px"}
                lineHeight={isMoreThanSm ? 1.5 : 1.71}
                color={"#4b5462"}
                mt={isMoreThanSm ? "15px" : "8px"}
              >
                Your dedicated customer success manager will be in contact with you to discuss next steps.
              </Box>
            </Box>

            <Box
              mt={isMoreThanSm ? 0 : "64px"}
              flex={1}
              maxWidth={isMoreThanSm ? "342px" : "332px"}
              margin={isMoreThanSm ? 0 : "0 auto"}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                height={"170px"}
              >
                <img src="images/quote/step_3.svg" alt="Step 3" height={"101px"} width={"117px"} />{" "}
                <Box
                  fontSize={isMoreThanSm ? "22px" : "18px"}
                  fontWeight={500}
                  lineHeight={isMoreThanSm ? 1.09 : 1.33}
                  color={"#160337"}
                >
                  Step 3
                </Box>
              </Box>
              <Box
                textAlign={"center"}
                fontSize={isMoreThanSm ? "16px" : "14px"}
                lineHeight={isMoreThanSm ? 1.5 : 1.71}
                color={"#4b5462"}
                mt={isMoreThanSm ? "15px" : "8px"}
              >
                Our installation teams will arrive on the agreed date to complete your installation in a safe, timely
                and tidy manner.
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
      {hasSpecialBackground && (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};
